export enum COLOR_NAMES {
  ERROR = 'error',
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  SURFACE = 'surface',
  TERTIARY = 'tertiary',
  WARNING = 'warning',
}

export enum THEME_VARIANT {
  DARK = 'dark',
  LIGHT = 'light',
}

export const surfaceDarkLightnessConfig = [
  { lightness: 14, name: 1 },
  { lightness: 17, name: 2 },
  { lightness: 20, name: 3 },
  { lightness: 24, name: 4 },
  { lightness: 28, name: 5 },
];

export const baseDarkLightnessConfig = [
  { lightness: 20, name: 0 },
  { lightness: 30, name: 5 },
  { lightness: 40, name: 10 },
  { lightness: 50, name: 20 },
  { lightness: 55, name: 30 },
  { lightness: 60, name: 40 },
  { lightness: 65, name: 50 },
  { lightness: 70, name: 60 },
  { lightness: 75, name: 70 },
  { lightness: 80, name: 80 },
  { lightness: 85, name: 90 },
  { lightness: 90, name: 95 },
  { lightness: 95, name: 99 },
  { lightness: 100, name: 100 },
];

// ---------------------------------------------------------------- LIGHT ----------------------------------------------------------------

export const surfaceLightLightnessConfig = [
  { lightness: 95, name: 1 },
  { lightness: 97, name: 2 },
  { lightness: 98, name: 3 },
  { lightness: 99, name: 4 },
  { lightness: 100, name: 5 },
];

export const baseLightLightnessConfig = [
  { lightness: 100, name: 0 },
  { lightness: 99, name: 5 },
  { lightness: 95, name: 10 },
  { lightness: 90, name: 20 },
  { lightness: 80, name: 30 },
  { lightness: 70, name: 40 },
  { lightness: 60, name: 50 },
  { lightness: 50, name: 60 },
  { lightness: 40, name: 70 },
  { lightness: 30, name: 80 },
  { lightness: 20, name: 90 },
  { lightness: 10, name: 95 },
  { lightness: 5, name: 99 },
  { lightness: 0, name: 100 },
];

export const LIGHTNESS_SETTINGS = {
  [THEME_VARIANT.DARK]: {
    base: baseDarkLightnessConfig,
    error: baseLightLightnessConfig,
    surface: surfaceDarkLightnessConfig,
  },
  [THEME_VARIANT.LIGHT]: {
    base: baseLightLightnessConfig,
    error: baseDarkLightnessConfig,
    primary: baseDarkLightnessConfig,
    surface: surfaceLightLightnessConfig,
  },
};

export const royalBluePaletteConfig = [
  {
    hue: 232,
    name: 'primary',
    saturation: 50,
  },
  {
    hue: 242,
    name: 'secondary',
    saturation: 32,
  },
  {
    hue: 232,
    name: 'tertiary',
    saturation: 28, // constant
  },
  {
    hue: 346,
    name: 'error',
    saturation: 40,
  },
  {
    hue: 169,
    name: 'success',
    saturation: 40,
  },
  {
    hue: 32,
    name: 'warning',
    saturation: 60,
  },
  {
    hue: 232,
    name: 'neutral',
    saturation: 10,
  },
  {
    hue: 232,
    name: 'surface',
    saturation: 28,
  },
];

export const basePermanentConfig = {
  black: 'hsla(0, 0%, 0%, 1)',
  gradients: {
    manualItemBg:
      'radial-gradient(190.34% 141.18% at 0% 0%, #3A22C7 7.39%, #2A3277 100%)',
  },
  transparent: 'transparent',
  white: 'hsla(0, 0%, 100%, 1)',
};
